<template>
	<div class="bg-[#F5F2FB]">
		<SideBar class="col-span-2 w-full fixed z-30 oveflow-y-scroll"/>
		<div class="bg-[#F5F2FB] h-full min-h-screen w-full lg:pl-[280px]">
			<TopBar class="z-30 hidden w-full lg:block" />
			<main class="lg:h-screen w-full max-w-[1400px] h-full mx-auto">
				<div class="px-2 lg:px-6 pt-14 lg:pt-0 overflow-x-hidden items-center">
					<router-view class="lg:mt-1 mt-4 px-2 lg:px-4 mx-auto mb-48 items-center" />
				</div>
			</main>
		</div>
	</div>
</template>

<script>
import SideBar from '@/components/navbars/SideBar';
import TopBar from '@/components/navbars/TopBar';

export default {
	name: "DashboardView",
	components: {
		SideBar,
		TopBar
	}
}
</script>
<style>

</style>